import type { AppDispatch } from '/business/shared/state/store';

import setBasketMeta from '/business/shared/state/actions/basket/setBasketMeta';

import { basketMetaUpdateKeys } from '/business/shared/util/Statics';
import type { ElectricityHeatSteamRenewableCertificate } from '/business/shared/state/selectors/application/electricityHeatSteam/electHeatSteamTypes';

const saveCertificate =
  ({
    certificate,
    isDelete = false,
    applicationId,
  }: {
    certificate: ElectricityHeatSteamRenewableCertificate;
    isDelete?: boolean;
    applicationId: number | null;
  }) =>
  async (dispatch: AppDispatch) => {
    if (!applicationId) {
      throw new Error('Application Id is missing');
    }
    if (isDelete && !certificate.id) {
      throw new Error('id is missing for delete');
    }

    await dispatch(
      setBasketMeta({
        item: {
          key: basketMetaUpdateKeys.PACKAGE2_CERT,
          data: {
            certificate: {
              ...certificate,
              itemId: certificate.id,
            },
            isDelete,
          },
        },
        applicationId,
        isConfirmedByUser: false,
      }),
    );
  };

export default saveCertificate;
